import React from 'react';
import { useDarkMode } from '../darkmode/DarkModeContext';
import { 
  CheckCircleIcon,
  ClockIcon,
  BanknotesIcon,
  DocumentTextIcon,
} from '@heroicons/react/24/outline';

const Stats = ({ bills }) => {
  const { isDarkMode } = useDarkMode();

  const formatCurrency = (amount) => {
    return new Intl.NumberFormat('id-ID', {
      style: 'currency',
      currency: 'IDR',
      minimumFractionDigits: 0
    }).format(amount || 0);
  };

  // Hitung total tunggakan (outstanding)
  const totalOutstanding = bills
    .filter(b => ['pending', 'overdue', 'failed', 'partial'].includes(b.payment?.status))
    .reduce((sum, b) => sum + ((b.pricing?.totalAmount || 0) - (b.payment?.paidAmount || 0)), 0);

  // Warna untuk kartu statistik
  const colorMap = {
    blue: { bg: 'bg-blue-100', text: 'text-blue-600' },
    green: { bg: 'bg-green-100', text: 'text-green-600' },
    yellow: { bg: 'bg-yellow-100', text: 'text-yellow-600' },
    red: { bg: 'bg-red-100', text: 'text-red-600' },
  };

  const stats = [
    { 
      label: 'Total Tagihan', 
      value: bills.length, 
      color: 'blue', 
      icon: <DocumentTextIcon className="h-5 w-5" /> 
    },
    { 
      label: 'Lunas', 
      value: bills.filter(b => b.payment?.status === 'paid').length, 
      color: 'green', 
      icon: <CheckCircleIcon className="h-5 w-5" /> 
    },
    { 
      label: 'Belum Bayar', 
      value: bills.filter(b => ['pending', 'overdue'].includes(b.payment?.status)).length, 
      color: 'yellow', 
      icon: <ClockIcon className="h-5 w-5" /> 
    },
    { 
      label: 'Total Tunggakan', 
      value: formatCurrency(totalOutstanding), 
      color: 'red', 
      icon: <BanknotesIcon className="h-5 w-5" />,
      isAmount: true
    }
  ];

  return (
    <div className="grid grid-cols-2 md:grid-cols-4 gap-4 mb-8">
      {stats.map((stat, index) => {
        const colors = colorMap[stat.color];
        return (
          <div 
            key={index} 
            className={`${
              isDarkMode ? 'bg-gray-800 border-gray-700' : 'bg-white border-gray-200'
            } border rounded-xl p-4 transition-colors`}
          >
            <div className="flex items-center justify-between">
              <div>
                <p className={`text-sm font-medium ${isDarkMode ? 'text-gray-400' : 'text-gray-500'}`}>
                  {stat.label}
                </p>
                <p className={`${stat.isAmount ? 'text-lg' : 'text-2xl'} font-bold ${isDarkMode ? 'text-white' : 'text-gray-900'}`}>
                  {stat.value}
                </p>
              </div>
              <div className={`p-2 rounded-lg ${colors.bg}`}>
                <div className={colors.text}>
                  {stat.icon}
                </div>
              </div>
            </div>
          </div>
        );
      })}
    </div>
  );
};

export default Stats;
